import 'vuetify/src/stylus/app.styl';
import { Scroll } from 'vuetify/es5/directives';
import {
	Vuetify,
	VAlert,
	VApp,
	VBtn,
	VBtnToggle,
	VCard,
	VCheckbox,
	VChip,
	VDataIterator,
	VDatePicker,
	VDialog,
	VDivider,
	VForm,
	VGrid,
	VIcon,
	VList,
	VMenu,
	VNavigationDrawer,
	VRadioGroup,
	VSelect,
	VSlider,
	VSnackbar,
	VSubheader,
	VTextField,
	VTimePicker,
	VToolbar,
	VTooltip,
	transitions,
	VExpansionPanel,
	VDataTable,
	VProgressLinear,
	VTabs,
	VStepper,
	VSwitch,
	VProgressCircular,
	VPagination,
} from 'vuetify';

export default function (Vue) {
	Vue.use(
		Vuetify,
		{
			components: {
				VAlert,
				VApp,
				VBtn,
				VBtnToggle,
				VCheckbox,
				VChip,
				VCard,
				VDataIterator,
				VDatePicker,
				VDialog,
				VDivider,
				VForm,
				VGrid,
				VIcon,
				VList,
				VMenu,
				VNavigationDrawer,
				VRadioGroup,
				VSelect,
				VSlider,
				VSnackbar,
				VSubheader,
				VTextField,
				VTimePicker,
				VToolbar,
				VTooltip,
				transitions,
				VExpansionPanel,
				VDataTable,
				VProgressLinear,
				VTabs,
				VStepper,
				VSwitch,
				VProgressCircular,
				VPagination,
			},
			theme: {
				primary: '#05579b',
				secondary: '#085f65',
				accent: '#b1dc03',
				error: '#FF5253',
				info: '#2DB6F5',
				success: '#4DC68C',
				warning: '#FFB74C',
				pink: '#fe6b7d',
				tab: '#255e70',
				slide: '#37abd0',
				lightBlue: '#44b4e5',
				yellowFav: '#efce4a',
				buttonLogin: '#02979b',
				buttonCenter: '#1f87e5',
				baseText: '#4a4a4a',
				theme1: '#b1dc03',
				theme2: '#ffec00',
				theme3: '#2266aa',
				theme4: '#08b4cd',
				theme5: '#ede200',
				gray: '#494949',
			},
			directives: {
				Scroll,
			},
		},
	);
}



// WEBPACK FOOTER //
// ./src/vuetify.js